module.exports = __webpack_public_path__ + "static/turtle-creek-house48-f316b3d2f16ac1289c57207ec8757031.jpg";